import type { CncSpeciesAssignment, RfqProject, TimberSupplierInvite } from '../types';
import { sanitizeCncSpeciesAssignments } from './cncRfqAssignments';
import {
  stampPmCncInviteInputAdjustment,
  type PmQuoteInputActor,
} from './rfqPmQuoteInputStamp';

export function patchTimberSupplierInvite(
  invites: TimberSupplierInvite[] | undefined,
  orgId: string,
  patch: Partial<TimberSupplierInvite>,
): TimberSupplierInvite[] {
  const list = invites ?? [];
  const idx = list.findIndex((i) => i.supplierOrgId === orgId);
  if (idx < 0) {
    return [...list, { supplierOrgId: orgId, requestedSpecies: [], ...patch }];
  }
  return list.map((inv) =>
    inv.supplierOrgId === orgId ? { ...inv, ...patch } : inv,
  );
}

export async function updateCncInviteSpeciesAssignments(
  updateRfqProject: (id: string, updates: Partial<RfqProject>) => Promise<void>,
  project: RfqProject,
  orgId: string,
  assignments: CncSpeciesAssignment[],
  actor: PmQuoteInputActor,
): Promise<void> {
  if (!project.id) throw new Error('RFQ project is missing.');
  const cleaned = sanitizeCncSpeciesAssignments(assignments);
  const nextInvites = patchTimberSupplierInvite(project.timberSupplierInvites, orgId, {
    cncSpeciesAssignments: cleaned,
    ...stampPmCncInviteInputAdjustment(actor),
  });
  await updateRfqProject(project.id, { timberSupplierInvites: nextInvites });
}
